/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import type { SocketTransportConfigParams } from './interfaces';

export class SocketTransportConfig {

    protected readonly restPrefix: string;
    protected readonly baseUrl: string;

    constructor(socketTransportConfigParams: SocketTransportConfigParams) {
        const {
            restPrefix = '',
            baseUrl = '',
        } = socketTransportConfigParams;

        this.restPrefix = restPrefix;
        this.baseUrl = baseUrl;
    }

    getRestPrefix(): string {
        return this.restPrefix;
    }

    getBaseUrl(): string {
        return this.baseUrl;
    }

}
